import { AiChatColumnFormat } from "@app/projects/network-assessment/provider-hub/interfaces";

// The backend decides which columns get which format (AiChatColumnFormatRegistry) and sends it as
// per-column metadata (columnFormats); this file only renders it. Cell values arrive as unformatted strings.

// Only a plain backend number is formatted; "None", "Unknown", empty cells and Markdown links pass through.
const PLAIN_NUMBER_PATTERN = /^-?\d+(\.\d+)?$/;

// Matches what currencyFormatter emits ("$1,234.00", "-$50.00") so formatted cells still sort numerically.
const CURRENCY_PATTERN = /^-?\$(\d{1,3}(,\d{3})*|\d+)(\.\d+)?$/;

const currencyFormatter = new Intl.NumberFormat("en-US", {
  currency: "USD",
  maximumFractionDigits: 2,
  minimumFractionDigits: 2,
  style: "currency",
});

const formatCurrency = (cell: string): string => {
  const trimmed = cell.trim();
  return PLAIN_NUMBER_PATTERN.test(trimmed) ? currencyFormatter.format(Number(trimmed)) : cell;
};

export const formatCell = (format: AiChatColumnFormat | undefined, cell: string): string => {
  switch (format) {
    case AiChatColumnFormat.Currency:
      return formatCurrency(cell);
    default:
      return cell;
  }
};

export const parseCurrencyCell = (cell: string): number | null =>
  CURRENCY_PATTERN.test(cell) ? parseFloat(cell.replace(/[$,]/g, "")) : null;
